import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import PropagateLoader from "react-spinners/PropagateLoader";
import axios from 'axios';
import { API_URL } from './config';
import PrivateRoute from './Utils/PrivateRoute';
import { getToken } from './Utils/Common';
import AppHeader from './components/Header/Header';
import AppFooter from './components/Footer/Footer';
import Maintenance from './components/Maintenance';

import { APP_INFO } from './Utils/appConstants';
import { reactLocalStorage } from 'reactjs-localstorage';

import commonRoutes from './Utils/commonRoutes';
import adminRoutes from './Utils/adminRoutes';
import partnerRoutes from './Utils/partnerRoutes';
import distributorRoutes from './Utils/distributorRoutes';
import stateHeadRoutes from './Utils/stateHeadRoutes';
import superDistributorRoutes from './Utils/superDistributorRoutes';
import masterDistributorRoutes  from './Utils/masterDistributorRoutes';
import venderRoutes from './Utils/venderRoutes';


require('dotenv').config();
function App() {
  const [authLoading, setAuthLoading] = useState(true);
  const [isMaintenance, setIsMaintenance] = useState(false);
  useEffect(() => {
    // console.log("App ----------------------------------");
    const token = getToken();
    if (!token) {
      return;
    }
    checkUnderMaintenance();
    setAuthLoading(false);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const checkUnderMaintenance = () => {
    axios.get(API_URL + `/appinfo`).then(response => {
      setAuthLoading(true);
      if (response) {
        reactLocalStorage.set(APP_INFO, JSON.stringify(response.data), true);
        setIsMaintenance(response.data.isMaintenance);
      }
      setAuthLoading(false);
    }).catch(error => {
      setAuthLoading(false);
    });
  }

  if (authLoading && getToken()) {
    return <div className="content text-center" style={{ margin: "250px 0" }}>
      <PropagateLoader color="#5851D2" loading={authLoading} size={25} />
    </div>
  }
  if (isMaintenance) {
    return (<><AppHeader /><Maintenance message="We are currently under maintenance. Please check back later." /></>)
  }

  return (
    <div className="App">
      <Router>
        <AppHeader />
        <div className="wrapper">

        <Switch>
            {[...commonRoutes, ...adminRoutes, ...partnerRoutes, ...distributorRoutes, ...stateHeadRoutes, ...superDistributorRoutes, ...masterDistributorRoutes, ...venderRoutes].map((route, index) => (
              <PrivateRoute
                key={index}
                exact
                path={route.path}
                component={route.component}
                allowedRoles={route.allowedRoles}
              />
            ))}
          </Switch>

          {/* <Switch>
            {commonRoutes.map((route, index) => (
              <PrivateRoute
                key={`common-${index}`}
                exact
                path={route.path}
                component={route.component}
                allowedRoles={['admin', 'partner', 'distributor']}
              />
            ))}
  
            {adminRoutes.map((route, index) => (
              <PrivateRoute
                key={`admin-${index}`}
                exact
                path={route.path}
                component={route.component}
                allowedRoles={['admin']}
              />
            ))}
  
            {partnerRoutes.map((route, index) => (
              <PrivateRoute
                key={`partner-${index}`}
                exact
                path={route.path}
                component={route.component}
                allowedRoles={['partner']}
              />
            ))}
  
            {distributorRoutes.map((route, index) => (
              <PrivateRoute
                key={`distributor-${index}`}
                exact
                path={route.path}
                component={route.component}
                allowedRoles={['distributor']}
              />
            ))}
          </Switch> */}
        </div>
        <AppFooter />
      </Router>
    </div>
  );
  
}

export default App;